/** Altura e borda compartilhadas entre o topo do menu lateral e o TopBar. */
export const shellHeaderClass =
  'h-[5.5rem] shrink-0 border-b border-manejai-sand/80';

/** Largura do menu lateral (expandido: w-64 menos ~40px). */
export const sidebarExpandedWidthClass = 'w-[13.5rem]';
export const sidebarCollapsedWidthClass = 'w-[4.5rem]';
